export default function ($scope, $anchorScroll, AuthenticationService, FlashService, Restangular, states, prescriberTypes, user, progression, $location) {

    $scope.year = new Date().getFullYear();

    var date = new Date();
    date.setFullYear(date.getFullYear());
    $scope.maxdate = date;

    $scope.roles = {
        'ROLE_PATIENT' : 'patient',
        'ROLE_PRENSCRIPTOR' : 'prescriber',
        'ROLE_COMPANY' : 'company'
    };

    $scope.role = typeof user.roles == 'object' ? user.roles[0] : user.roles;

    $scope.prescriberTypes = prescriberTypes;
    $scope.states = states;
    $scope.type = $scope.roles instanceof Array ? $scope.roles[user.roles[0]] : $scope.roles[user.roles];
    $scope.email = user.email;
    $scope.company = user.company;
    $scope.cif = user.cif;
    $scope.postalCode = user.postal_code;
    $scope.city = user.city;
    $scope.address = user.address;
    $scope.prescriberType = user.prescriber_type ? user.prescriber_type.id : null;
    $scope.state = user.state ? user.state.id : null;
    $scope.birthday = user.birthday ? ParseDate(user.birthday) : null;
    $scope.name = user.name;
    $scope.surname = user.surname;

    $scope.$root.$watch('current_language', function(new_value){
        $scope.updatePrescriptorType(new_value);
    });

    $scope.updatePrescriptorType =  function(language){
        if(!$scope.prescriberTypes || !language) return false;

        $scope.prescriberTypes.map(function(type){
            if(type['description_'+language])
                type.label = type['description_'+language];
            else
                type.label = type['description'];

            return type;
        })
    }

    $scope.$watch('email', function(){
        $scope.form.email.$setValidity('exists', true);
    });

    $scope.register = function () {
        $scope.dataLoading = true;
        progression.start();

        var birthday = null;

        if($scope.birthday){
            var date = new Date($scope.birthday);
            birthday = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
        }

        var user = {
            username : $scope.username,
            email : $scope.email,
            plainPassword : $scope.plainPassword,
            name : $scope.name ? $scope.name : $scope.company,
            surname : $scope.surname,
            birthday: birthday,
            prescriberType: $scope.precriberType,
            city: $scope.city,
            address: $scope.address,
            postalCode: $scope.postalCode,
            state: $scope.state,
            cif: $scope.cif,
        };

        if(!$scope.plainPassword)
            delete user.plainPassword;

        if(!birthday)
            delete user.birthday;


        Restangular
            .all('user')
            .patch(user)
            .then(data => {

                $location.path('/account');

                FlashService.Success("PROFILE_UPDATE");
                progression.done();

                $scope.dataLoading = false;
            }, error => {
                $scope.dataLoading = false;

                $anchorScroll("body");
                FlashService.Error("MALFORMET_DATA");
                progression.done()

                error.data.fields.forEach(function(field, index){
                    if(field.property_path == 'email' || field.property_path == 'username'){
                        $scope.form[field.property_path].$setValidity('exists', false);
                    }

                    if(field.property_path == 'plainPassword'){
                        $scope.form[field.property_path].$setValidity('low', false);
                    }
                });

                form.$invalid = false;

            });

    };
};


/** WEBPACK FOOTER **
 ** ./js/theme/profile/controller.js
 **/